module.exports = __webpack_public_path__ + "img/afterRegister.cbe7222a.cbe7222a.svg";